import React from 'react';
import { useLocation } from 'react-router-dom';
import AppLayout from './AppLayout';
import { useAuth } from '../../contexts/AuthContext';

const SIDEBAR_PATHS = new Set([
  '/home',
  '/dashboard',
  '/update-profile',
  '/search',
  '/user-redirect',
]);

/**
 * Routes that use the TikTok-style shell (sidebar + main).
 * `/bookstore` only when logged in — guests get normal Header + full-width page.
 */
export function shouldShowAppSidebar(pathname, currentUser = null) {
  if (pathname.startsWith('/user/')) return true;
  if (pathname === '/bookstore') return !!currentUser;
  return SIDEBAR_PATHS.has(pathname);
}

export default function AppShell({ children }) {
  const { pathname } = useLocation();
  const { currentUser } = useAuth();

  if (shouldShowAppSidebar(pathname, currentUser)) {
    return <AppLayout>{children}</AppLayout>;
  }

  return <>{children}</>;
}
